import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useState } from "react";
import { Card, Grid } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useCustomerValue } from "providers/CustomerContext";
import { getPutawayNumberOption,getPutawayReport } from "services/data.report.service";
import { InboundLayout } from "ui-components/Layout";
import { LoadingDialog } from "ui-components/Alert";
import { SelectFields } from "ui-components/Form";
import { downloadPDF2, downloadFile } from "layouts/views/common/file"; 
import { Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";

function PutawayReport() {
  const {permissions, allowAll} = useTeamValue()
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ content="Invalid Request" onChange={setAlert} />);
  const exportPermission = allowAll || (Boolean(permissions["Putaway Report_Report"]) && permissions["Putaway Report_Report"].findIndex(b => b==="export") !== -1);

  const downloadReportMutation = useMutation(getPutawayReport, {
    onSuccess: (response) => {
      if (reportType === "PDF") {
        downloadPDF2(response.data,`${putawayNumber}.pdf`);
      } else {
        downloadFile(response.data, `${putawayNumber}.csv`);
      }
    },
    onError,
  });

  const [putawayNumberOptions, setputawayNumberOptions] = useState([]);
  const [putawayNumber, setPutawayNumber] = useState(null);
  const [reportType, setReportType] = useState("PDF");

  const handleSubmit = () => {
    setAlert(null);
    downloadReportMutation.mutate({
      customerCode,
      putawayNumber,
      reportType,
      reportName: "Putaway",
    });
  };

  useQuery({
    queryKey: ["report-putaway", { customerCode }],
    queryFn: () => getPutawayNumberOption({ customerCode }),
    enabled:Boolean(customerCode),
    onSuccess: (data) => {
      setPutawayNumber(null);
      setputawayNumberOptions(data.data.data);
    },
  });

  const downloadStatus = downloadReportMutation.status === "loading";

  return (
    <InboundLayout>
      {downloadStatus && <LoadingDialog />}

      <Card sx={{ height: "100%" }}>
        <MDBox p={3}>
          {alert}
          <MDBox pb={3}>
            <MDTypography color="info" variant="h3">
              Export Putaway Report
            </MDTypography>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "putawayNumber",
                  label: "Putaway Number",
                  value: putawayNumber,
                  errors: {},
                  required: true,
                }}
                options={putawayNumberOptions}
                onChange={(e, v) => setPutawayNumber(v)}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "reportType",
                  label: "Export to File Type *",
                  value: reportType,
                  errors: {},
                  required: true,
                }}
                options={["PDF", "CSV"]}
                onChange={(e, v) => setReportType(v)}
              />
            </Grid>
          </Grid>

          <MDBox mt={2} display="flex" justifyContent="center">
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              disabled={!Boolean(putawayNumber) || !exportPermission}
              onClick={handleSubmit}
            >
              Download
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </InboundLayout>
  );
}

export default PutawayReport;
